<template>
	<div>
		<button
			type="button"
			class="flex w-full items-center justify-between gap-2 py-2 text-left text-sm text-neutral-600"
			:aria-expanded="isOpen"
			:aria-controls="panelId"
			data-cy="extra_night_pricing_toggle"
			@click="isOpen = !isOpen"
		>
			<span class="block">{{ t('extra_night_breakdown_title') }}</span>
			<ChevronIcon class="h-2.5 flex-none transition-transform" :class="isOpen ? '-rotate-90' : 'rotate-90'" />
		</button>

		<div
			:id="panelId"
			:inert="!isOpen"
			:class="{
        'overflow-hidden transition-accordion': true,
        'max-h-0 opacity-0 duration-200': !isOpen,
        'max-h-800 opacity-100 duration-500': isOpen,
      }"
		>
			<ExtraNightPricingLines class="pb-2" />
		</div>
	</div>
</template>

<script lang="ts" setup>
import { ref, useId } from 'vue';
import { useI18n } from 'vue-i18n';
import ExtraNightPricingLines from '@/components/receipt/ExtraNightPricingLines.vue';
import ChevronIcon from '@/theme/icons/chevron.svg?component';

export interface Props {
  defaultOpen?: boolean
}

const props = withDefaults(defineProps<Props>(), { defaultOpen: false });

const { t } = useI18n();

const isOpen = ref(props.defaultOpen);

const panelId = useId();
</script>
